module.exports = __webpack_public_path__ + "img/reconhecimento.f3b48fde.svg";